/******** AUTO PLAY ON HOVER ***********/
class ProductCardVideo {
  constructor() {
    this.cards = document.querySelectorAll('.card-wrapper');
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    this.init();
  }

  init() {
    this.cards.forEach(card => {
      const videoContainer = card.querySelector('.video-container');
      const video = videoContainer?.querySelector('video');
      if (!video || !videoContainer) return;

      // Ensure proper mobile playback
      video.setAttribute('muted', true);
      video.setAttribute('playsinline', true);

      videoContainer.style.opacity = '0';
      videoContainer.style.display = 'none';

      const playVideo = () => {
        videoContainer.style.display = 'block';
        requestAnimationFrame(() => {
          videoContainer.style.opacity = '1';
        });
        video.currentTime = 0;
        video.play().catch(() => {});
      };

      const stopVideo = () => {
        video.pause();
        video.currentTime = 0;
        videoContainer.style.opacity = '0';
        setTimeout(() => {
          videoContainer.style.display = 'none';
        }, 300);
      };

      if (this.isTouchDevice) {
        card.addEventListener('touchstart', e => {
          playVideo();
        });

        card.addEventListener('touchmove', e => {
          const touch = e.touches[0];
          const rect = card.getBoundingClientRect();
          const inBounds =
            touch.clientX >= rect.left &&
            touch.clientX <= rect.right &&
            touch.clientY >= rect.top &&
            touch.clientY <= rect.bottom;

          if (!inBounds) stopVideo();
        });

        card.addEventListener('touchend', stopVideo);
        card.addEventListener('touchcancel', stopVideo);
      } else {
        // Desktop hover behavior
        card.addEventListener('mouseenter', playVideo);
        card.addEventListener('mouseleave', stopVideo);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductCardVideo();
});

/******** CUSTOM QUICK VIEW POP-UP ***********/
// Modified initialization function
function initQuickView() {
  const quickView = document.querySelector(".custom-quick-view:not(.initialized)");
  if (!quickView) return;

  // Mark as initialized
  quickView.classList.add('initialized');

  // Cleanup previous event listeners
  const cleanups = [];

  // Gallery functionality
  const slides = quickView.querySelectorAll(".cqv-slide");
  const thumbs = quickView.querySelectorAll(".cqv-thumb");
  const prevButtons = quickView.querySelectorAll(".cqv-nav.prev");
  const nextButtons = quickView.querySelectorAll(".cqv-nav.next");
  const counters = quickView.querySelectorAll("[data-current]");
  const thumbnailsContainer = quickView.querySelector('.cqv-thumbnails');
  let current = 0;

  // Center active thumbnail function
  function centerActiveThumbnail() {
    if (!thumbnailsContainer || !thumbs[current]) return;
    
    const activeThumb = thumbs[current];
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    
    if (isMobile) {
      const scrollLeft = activeThumb.offsetLeft - (thumbnailsContainer.offsetWidth / 2) + (activeThumb.offsetWidth / 2);
      thumbnailsContainer.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    } else {
      const scrollTop = activeThumb.offsetTop - (thumbnailsContainer.offsetHeight / 2) + (activeThumb.offsetHeight / 2);
      thumbnailsContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });
    }
  }

  function updateSlide(index) {
    slides.forEach((slide, i) => slide.classList.toggle("active", i === index));
    thumbs.forEach((thumb, i) => thumb.classList.toggle("active", i === index));
    counters.forEach(counter => counter.textContent = index + 1);
    current = index;
    centerActiveThumbnail();
  }

  // Thumbnail click handlers
  thumbs.forEach((thumb, index) => {
    const handler = () => updateSlide(index);
    thumb.addEventListener("click", handler);
    cleanups.push(() => thumb.removeEventListener("click", handler));
  });

  // Navigation handlers for both desktop and mobile buttons
  const navHandler = direction => {
    const newIndex = (current + direction + slides.length) % slides.length;
    updateSlide(newIndex);
  };

  prevButtons.forEach(button => {
    const handler = () => navHandler(-1);
    button.addEventListener("click", handler);
    cleanups.push(() => button.removeEventListener("click", handler));
  });

  nextButtons.forEach(button => {
    const handler = () => navHandler(1);
    button.addEventListener("click", handler);
    cleanups.push(() => button.removeEventListener("click", handler));
  });

  // Initial setup
  updateSlide(0);
  centerActiveThumbnail();

  // Variant selection
const variantSelect = quickView.querySelector("select[name='id']");
const variantInput = quickView.querySelector("#cqv-variant-id");
if (variantSelect && variantInput) {
  const variantHandler = function() {
    variantInput.value = this.value;
  };
  variantSelect.addEventListener("change", variantHandler);
  cleanups.push(() => variantSelect.removeEventListener("change", variantHandler));
}

// Listen for variantChange from <variant-selects> (if present)
const variantComponent = quickView.querySelector("variant-selects");
if (variantComponent && variantInput) {
  const onVariantChange = (event) => {
    const variant = event.detail.variant;
    if (variant) {
      variantInput.value = variant.id;
    }
  };
  variantComponent.addEventListener("variantChange", onVariantChange);
  cleanups.push(() => variantComponent.removeEventListener("variantChange", onVariantChange));
}
  
  // Custom Field
  const personalizationField = quickView.querySelector('.personalization-field');
const personalizationTextarea = quickView.querySelector('.personalization-textarea');
const variantSelects = quickView.querySelectorAll('.product-variants select');

function updatePersonalizationField() {
  let shouldHide = false;
  const forbiddenWords = ['no', 'blank'];
  
  variantSelects.forEach(select => {
    const value = select.value.trim().toLowerCase();
    if (forbiddenWords.some(word => value.includes(word))) {
      shouldHide = true;
    }
  });

  // Get the parent container
  const personalizationContainer = quickView.querySelector('.personalization-field');
  
  if (shouldHide) {
    personalizationContainer.style.display = 'none';
    personalizationTextarea.disabled = true;
  } else {
    personalizationContainer.style.display = 'block';
    personalizationTextarea.disabled = false;
  }
}

// Initial check
updatePersonalizationField();

// Add variant change listeners
variantSelects.forEach(select => {
  const handler = () => updatePersonalizationField();
  select.addEventListener('change', handler);
  cleanups.push(() => select.removeEventListener('change', handler));
});

  // Quantity functionality
  const qtyInput = quickView.querySelector('.custom-qty-input');
  const minusBtn = quickView.querySelector('.custom-qty-btn.minus');
  const plusBtn = quickView.querySelector('.custom-qty-btn.plus');

  function updateButtonState() {
    const value = parseInt(qtyInput.value);
    minusBtn.classList.toggle('active', value > 1);
    minusBtn.style.opacity = value > 1 ? '1' : '0.5';
    minusBtn.style.cursor = value > 1 ? 'pointer' : 'not-allowed';
  }

  if (plusBtn && minusBtn && qtyInput) {
    const plusHandler = () => {
      qtyInput.value = parseInt(qtyInput.value) + 1;
      updateButtonState();
    };
    const minusHandler = () => {
      if (parseInt(qtyInput.value) > 1) {
        qtyInput.value = parseInt(qtyInput.value) - 1;
        updateButtonState();
      }
    };
    const inputHandler = () => {
      if (qtyInput.value < 1 || isNaN(qtyInput.value)) {
        qtyInput.value = 1;
      }
      updateButtonState();
    };

    plusBtn.addEventListener('click', plusHandler);
    minusBtn.addEventListener('click', minusHandler);
    qtyInput.addEventListener('change', inputHandler);
    
    cleanups.push(
      () => plusBtn.removeEventListener('click', plusHandler),
      () => minusBtn.removeEventListener('click', minusHandler),
      () => qtyInput.removeEventListener('change', inputHandler)
    );
    
    updateButtonState();
  }

  // Cleanup when modal closes
  const observer = new MutationObserver((mutations) => {
    if (!document.body.contains(quickView)) {
      cleanups.forEach(cleanup => cleanup());
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize when modal opens
document.addEventListener('DOMContentLoaded', initQuickView);
document.addEventListener('shopify:section:load', initQuickView);

// For dynamic content
let initTimeout;
function checkForQuickView() {
  initQuickView();
  initTimeout = setTimeout(checkForQuickView, 500);
}
checkForQuickView();

// Clear timeout when leaving page
window.addEventListener('beforeunload', () => {
  clearTimeout(initTimeout);
});

// Handle variant changes from <variant-selects>
const variantComponent = quickView.querySelector("variant-selects");
const hiddenInput = quickView.querySelector("#cqv-variant-id");

if (variantComponent && hiddenInput) {
  const onVariantChange = (event) => {
    const variant = event.detail.variant;
    if (variant) {
      hiddenInput.value = variant.id;
    }
  };

  variantComponent.addEventListener("variantChange", onVariantChange);
  cleanups.push(() => variantComponent.removeEventListener("variantChange", onVariantChange));
}